import React from 'react';
import { IconButton, Typography } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import CloseIcon from '../../../icons/CloseIcon';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		container: {
			minHeight: 60,
			background: theme.palette.background.paper,
			borderBottom: `1px solid ${theme.palette.divider}`,
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
			padding: '4px 8px 4px 16px',
			flexShrink: 0,
		},
	}),
);

interface BackgroundSelectionHeaderProps {
	onClose: () => void;
}

export default function BackgroundSelectionHeader({
	onClose,
}: BackgroundSelectionHeaderProps) {
	const classes = useStyles();
	return (
		<div className={classes.container}>
			<Typography variant="h6" component="h2" id="background-panel-title">
				Background
			</Typography>
			<IconButton aria-label="Close background panel" onClick={onClose}>
				<CloseIcon />
			</IconButton>
		</div>
	);
}
